import React from 'react';
import PropTypes from 'prop-types';

const ScrollableContent = ({ children, containerRef, className }) => {
    const initRef = (ref) => {
        if (typeof containerRef === 'function') {
            containerRef(ref);
        }
    };

    return (
        <div ref={initRef} className={className} style={{ position: 'relative', width: '100%', height: '100%', overflow: 'auto' }}>
            {children}
        </div>
    );
};

ScrollableContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
    containerRef: PropTypes.func,
    className: PropTypes.string
};

export default ScrollableContent;